<ng-container>
  <div class="filter-section">
    <form [formGroup]="searchForm" class="clrsgn-form search-form">
      <div class="row">
        <div class="col-3">
          <mat-form-field appearance="fill" class="clrsgn-form-field">
            <mat-label for="loanNumber" class="clrsgn-label">Loan Number</mat-label>
            <input matInput
              type="text"
              formControlName="loanNumber"
              id="filterLoanNumber" />
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field appearance="fill" class="clrsgn-form-field">
              <mat-label for="clientLastName" class="clrsgn-label">Client Last Name</mat-label>
              <input matInput
                type="text"
                formControlName="clientLastName"
                id="filterClientLastName" />
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field appearance="fill" class="clrsgn-form-field">
                <mat-label class="clrsgn-label">Schedule Date</mat-label>
                <mat-date-range-input [formGroup]="searchScheduledDate" [rangePicker]="picker">
                  <input data-cy="scheduledDateStartDate" matStartDate formControlName="startDate">
                  <input data-cy="scheduledDateEndDate" matEndDate formControlName="endDate">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker">
                  <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                </mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
                @if (!searchScheduledDate.get('startDate')?.hasError('required')) {
                  <mat-hint>
                    <app-form-error [group]="searchScheduledDate" [controlName]="'startDate'"></app-form-error>
                    <app-form-error [group]="searchScheduledDate" [controlName]="'endDate'"></app-form-error>
                  </mat-hint>
                }
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field appearance="fill" class="clrsgn-form-field">
                <mat-label for="address" class="clrsgn-label">Street Address</mat-label>
                <input matInput
                  type="text"
                  formControlName="address"
                  id="filterAddress" />
                </mat-form-field>
              </div>
              <div class="col-3">
                <mat-form-field appearance="fill" class="clrsgn-form-field">
                  <mat-label for="thirdPartyOrderIdentifier" class="clrsgn-label">3rd Party Order ID</mat-label>
                  <input matInput
                    formControlName="thirdPartyOrderIdentifier"
                    id="filterThirdPartyOrderIdentifier" />
                  </mat-form-field>
                </div>
                <div class="col-3">
                  <mat-form-field appearance="fill" class="clrsgn-form-field">
                    <mat-label for="clients" class="clrsgn-label">Organization</mat-label>
                    <mat-select formControlName="client" (selectionChange)="onSetClient($event.value)" data-cy="organizationDropdown" #clientSelect>
                      <small class="text-muted ps-3">Search:</small>
                      <input matInput placeholder="Filter" class="clrsgn-form-field mat-option ps-3" formControlName="clientFilter" (input)="performClientFilter()" #clientInput>
                      <hr />
                      @for (client of filteredClients; track client) {
                        <mat-option
                          [value]="client.clientId">
                          {{ client.clientName }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                @if (isOrderManager && (isPortalAssigneeEnabled$ | async)) {
                  <div class="col">
                    <mat-form-field appearance="fill" class="clrsgn-form-field">
                      <mat-label for="assignees" class="clrsgn-label">Assigned To</mat-label>
                      <mat-select (selectionChange)="onSetAssignee($event.value)" data-cy="assigneeDropdown">
                        <input placeholder="Search Assignees" class="clrsgn-form-field" (keyup)="assigneeLoader($event.target.value)">
                        <mat-option value="">
                          No Search Filter
                        </mat-option>
                        @for (assignee of (filteredAssignees$ | async); track assignee) {
                          <mat-option
                            [value]="assignee">
                            {{ assignee.fullName }} <span class="emailAddress">{{ assignee.emailAddress }}</span>
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
                <div class="col-3">
                  <mat-form-field appearance="fill" class="clrsgn-form-field">
                    <mat-label for="orderStatus" class="clrsgn-label">Order Status</mat-label>
                    <mat-select formControlName="orderStatus" (selectionChange)="onSetOrderStatus($event.value)" data-cy="orderStatusDropdown">
                      @for (orderStatus of orderStatuses; track orderStatus) {
                        <mat-option
                          [value]="orderStatus.value">
                          {{ orderStatus.displayValue }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="row form-actions">
                <div class="col-3">
                  <button type="button"
                    class="btn-primary action-btn filter-btn"
                    (click)="onSearch()">
                    Apply Filters
                  </button>
                  &nbsp;
                  <button type="button"
                    class="btn-tertiary action-btn reset-btn"
                    (click)="onReset()">
                    Reset
                  </button>
                </div>
                <div class="col-3">
                  <mat-slide-toggle id="ViewMyOrders"
                    formControlName="viewMyOrders"
                    name="ViewMyOrders"
                    labelPosition="before"
                    (change)="onSearchViewSwap()"
                    matTooltip="Shows orders you have created or have been assigned to as the Signing Agent"
                    placement="auto"
                    container="body"
                    openDelay="500">
                    View My Orders
                  </mat-slide-toggle>
                </div>
              </div>
            </form>
          </div>
        </ng-container>
